<template>
  <div class="events-container" :class="{active:!loading}">
    <div class="wrapper" ref="wrapper">
      <div class="content">
        <timeline class="timeline">

          <timeline-item class="bold title">
            <div slot="left">
              <div>history</div>
              <div>of</div>
              <div class="red">yindu ogilvy</div>
            </div>
          </timeline-item>


          <timeline-item class="medium desc">
            <div slot="left">
              <div>从1994年的银都商场的广告宣传部门</div>
              <div>发展至年营业额超13亿的</div>
              <div class="red">“中国广告一级企业”</div>
              <div>银都奥美历经二十多年来飞速发展</div>
              <div> 成为了全国知名的广告创意传播集团</div>
            </div>
          </timeline-item>


          <timeline-item class="year">
            <div slot="left">
              <div class="ename bold">
                <div>Founded</div>
                <div>in</div>
                <div class="red">Nanjing</div>
              </div>
              <div class="cname medium">
                <div>银都广告</div>
                <div>在南京成立</div>
              </div>
            </div>
            <div slot="right">
              <div>19<br/>94</div>
            </div>
          </timeline-item>


          <timeline-item class="years heavy" v-for="(year) in [1995,1996,1997,1998]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>


          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Entered</div>
                <div class="red">national</div>
                <div class="red">market</div>
              </div>
              <div class="cname medium">
                <div>业务走向全国</div>
              </div>
            </div>
            <div slot="right">
              <div>19<br/>99</div>
            </div>
          </timeline-item>


          <timeline-item class="years" v-for="(year) in [2000,2001,2002]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>

          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Reached</div>
                <div class="red">100 million RMB </div>
                <div>sales</div>
              </div>
              <div class="cname medium">
                <div>营业额破1亿 </div>
              </div>
            </div>
            <div slot="right">
              <div>20<br/>03</div>
            </div>
          </timeline-item>

          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Ranked <span class="red">No.30</span></div>
                <div>among </div>
                <div>local agencies </div>
              </div>
              <div class="cname medium">
                <div>本土广告No.30</div>
              </div>
            
            </div>
            <div slot="right">
              <div>20<br/>04</div>
            </div>
          </timeline-item>


          <timeline-item class="years" v-for="(year) in [2005,2006]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>


          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Ranked <span  class="red">No.5</span></div>
                <div>among </div>
                <div>local agencies </div>
              </div>
              <div class="cname medium">
                <div>本土广告No.5</div>
              </div>
            </div>
            <div slot="right">
              <div>20<br/>07</div>
            </div>
          </timeline-item>


          <timeline-item class="years" v-for="(year) in [2008,2009]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>


          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Ranked <span class="red">No.2</span></div>
                <div>among </div>
                <div>local agencies </div>
              </div>
              <div class="cname medium">
                <div>本土广告No.2</div>
              </div>
            
            </div>
            <div slot="right">
              <div>20<br/>10</div>
            </div>
          </timeline-item>


          <timeline-item class="years" v-for="(year) in [2011]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>


          <timeline-item>
            <div slot="left" class="red">
              <div class="ename bold">
                <div>Yindu Ogilvy</div>
                <div>was </div>
                <div>founded</div>
              </div>
              <div class="cname medium">
                <div>银都奥美挂牌</div>
              </div>
            </div>
            <div slot="right">
              <div class="red">20<br/>12</div>
            </div>
          </timeline-item>


          <timeline-item class="years" v-for="(year) in [2013,2014,2015,2016,2017]" :key="year">
            <div slot="left">
              <div>{{year}}</div>
            </div>
          </timeline-item>


          <timeline-item>
            <div slot="left">
              <div class="ename bold">
                <div>Reached over</div>
                <div class="red">2 billion  </div>
                <div>sales </div>
              </div>
              <div class="cname medium">
                <div>营业额超20亿</div>
              </div>
            </div>
            <div slot="right">
              <div>20<br/>18</div>
            </div>
          </timeline-item>


        </timeline>
      </div>
      <div class="icon-plus"></div>
    </div>
   
  </div>
</template>
<script>
import Bscroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
Bscroll.use(MouseWheel)
import Timeline from "../components/Timeline.vue"
import TimelineItem from "../components/TimelineItem.vue"
export default {
  data(){
    return {
      loading:true
    }
  },
  components:{
    Timeline,
    TimelineItem
  },
  mounted(){
    this.$nextTick(()=>{
      this.loading = false;
      this.scroll = new Bscroll(this.$refs.wrapper, {
        mouseWheel:true,
        probeType:3,
        disableMouse:false,
        bounce: {
          top:false
        }
      });
      
    })
  },
  beforeRouteLeave (to, from, next) {
    this.loading = true;
    next();
  }
}
</script>
<style lang="scss" scoped>
@import "../common/theme.scss";
  .events-container {
    font-family: source-han-sans-simplified-c, sans-serif;
    width: 100%;
    height: 100%;
    line-height: 1;
    padding: 120px 0 0px;
    text-transform: uppercase;
    box-sizing: border-box;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
  }
  .content {
    padding-bottom: 40px;
  }
  .red {
    color: $themeColor;
  }
  .title {
    font-size: 48px;
  }
  .desc {
    font-size: 18px;
    line-height: 24px;
  }
  .ename {
    font-size: 30px;
    line-height: 1.2;
  }
  .cname {
    font-size: 20px;
    line-height: 1.2;
    margin-top: 10px;
  }
  .years {
    font-size: 14px;
    color: #929292;
  }
  .timeline-item + .timeline-item {
    margin-top: 40px;
  }
  .years + .years {
    margin-top: 24px;
  }
  .wrapper {
    
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .icon-plus{
    position: absolute;
    width: 0;
    height: 0;
    left: 0px;
    right: 0;
    margin: auto;
    top: 120px;
    transform: scale(0);
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: #ed2024;
    }
    $width:6px;
    $height: 36px;
    &:after {
      width: $width;
      height: $height;
      top: -1 * ($height / 2);
      left: -1 * ($width / 2);
    }
    &:before {
      width: $height;
      height: $width;
      left: -1 * ($height / 2);
      top: -1 * ($width / 2);
    }
  }

  .wrapper /deep/ .split-line {
    transform-origin: top center;
    transform: translate3d(0,-100%,0);
  }
  .wrapper /deep/  .timeline   {
    .left-area  {
      .item-content{
        transform: translate3d(100%,0,0);
      }
    }
    .right-area  {
      .item-content{
        transform: translate3d(-100%,0,0);
      }
    }
  }
  
  .active {
    .icon-plus {
      animation: icon_anim .9s linear forwards;
    }
    .wrapper /deep/ .split-line {
      transform: none;
      transition: all 5s linear;
    }
    .wrapper /deep/  .timeline-item {
      @for $v from 1 to 28 {
        &:nth-child(#{$v}){
          .item-content {
            transition: all .8s .8s * ($v - 1) linear;
            transform: none;
          }
        }
      }
    }
  }
  
  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
</style>
